module.exports = __webpack_public_path__ + "green@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/skins/flat/green@2x.png
// module id = 1188
// module chunks = 0